import React from 'react';
const VARIANT_CLASSES = {
    primary: 'bg-blue-600 text-white hover:bg-blue-500 active:bg-blue-700',
    muted: 'bg-gray-200 text-gray-800 hover:bg-gray-300'
};
// Disabled state per the Figma mockups: pale blue with white text, not gray.
const DISABLED_CLASSES = 'bg-blue-200 text-white cursor-not-allowed';
const ActionButton = ({ label, onClick, variant = 'primary', disabled = false }) => {
    return (React.createElement("button", { type: "button", disabled: disabled, onClick: onClick, className: `
      rounded-lg px-6 py-2.5 text-base font-semibold transition-colors
      focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600
      ${disabled ? DISABLED_CLASSES : VARIANT_CLASSES[variant]}
    ` }, label));
};
export default ActionButton;
